module.exports = __webpack_public_path__ + "87c9e9d6ca9e5ec8a6f3a143b5e542c8.svg";